/**
 * Boot Modellen Service - API calls voor boot modellen
 */

import apiFetch from './api';

export interface BootModel {
  id: number;
  fabrikant: string;
  model: string;
  type_boot?: string;
  materiaal?: string;
  lengte?: number;
  breedte?: number;
  diepgang?: number;
  gewicht?: number;
  bouwjaar_vanaf?: number;
  bouwjaar_tot?: number;
  omschrijving?: string;
  actief: boolean;
  created_at: string;
  updated_at?: string;
}

export interface BootModelCreate {
  fabrikant: string;
  model: string;
  type_boot?: string;
  materiaal?: string;
  lengte?: number;
  breedte?: number;
  diepgang?: number;
  gewicht?: number;
  bouwjaar_vanaf?: number;
  bouwjaar_tot?: number;
  omschrijving?: string;
  actief?: boolean;
}

export interface BootModelFilters {
  skip?: number;
  limit?: number;
  actief?: boolean;
  zoek?: string;
}

export const bootModellenService = {
  async getAll(filters: BootModelFilters = {}): Promise<BootModel[]> {
    const params = new URLSearchParams();

    if (filters.skip !== undefined) params.append('skip', filters.skip.toString());
    if (filters.limit !== undefined) params.append('limit', filters.limit.toString());
    if (filters.actief !== undefined) params.append('actief', filters.actief.toString());
    if (filters.zoek) params.append('zoek', filters.zoek);

    return apiFetch(`/api/v1/boot-modellen?${params.toString()}`);
  },

  async getById(id: number): Promise<BootModel> {
    return apiFetch(`/api/v1/boot-modellen/${id}`);
  },

  async create(data: BootModelCreate): Promise<BootModel> {
    return apiFetch('/api/v1/boot-modellen', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  async update(id: number, data: Partial<BootModelCreate>): Promise<BootModel> {
    return apiFetch(`/api/v1/boot-modellen/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  async delete(id: number): Promise<void> {
    return apiFetch(`/api/v1/boot-modellen/${id}`, {
      method: 'DELETE',
    });
  },
};
